import { useMemo } from 'react';
import { useAppSelector } from 'careand-redux/store';
import {
  checkFeaturePermission,
  getAccessibleFeatures,
  FEATURE_PERMISSIONS,
  FeatureConfig
} from 'services/FeaturePermissions';

export function useFeatureAccess() {
  const authentication = useAppSelector(state => state.authentication);
  const { permissions, decodedToken } = authentication;
  const { role } = decodedToken;

  const accessibleFeatures = useMemo(() => {
    return getAccessibleFeatures(permissions, role!);
  }, [permissions, role]);

  const checkAccess = useMemo(() => {
    return (featureKey: string) => checkFeaturePermission(featureKey, permissions, role!);
  }, [permissions, role]);

  const getFeatureConfig = useMemo(() => {
    return (featureKey: string): FeatureConfig | undefined => FEATURE_PERMISSIONS[featureKey];
  }, []);

  const getBadgeCount = useMemo(() => {
    return (featureKey: string, state: any): number => {
      const feature = FEATURE_PERMISSIONS[featureKey];
      if (!feature?.badgeSelector) return 0;
      return feature.badgeSelector(state);
    };
  }, []);

  return {
    checkAccess,
    accessibleFeatures,
    getFeatureConfig,
    getBadgeCount,
    allFeatures: FEATURE_PERMISSIONS,
    permissions,
    role,
  };
}
